import { useAbTesting } from '@packages/abtesting';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { SimilarRecoFragmentFragmentDoc } from '@packages/gql/generated/shopping/SimilarRecoFragmentFragmentDoc';
import { SimilarProductsRecoSlider } from '@packages/recommendations';
import { useIntl } from 'react-intl';
import { similarProductsFallbackHeadline } from './messages';

/* GraphQL */ `
  fragment SimilarRecoFragment on Product {
    hasSeries
    promotion
    orderNumber
  }
`;

export type SimilarProductsProps = {
  /**
   * The data from the product query needed for the `SimilarProductsRecoSlider` comnponent.
   */
  data: FragmentType<typeof SimilarRecoFragmentFragmentDoc>;
};

const testId = '2023_09_reco_sequence';

/**
 * This component is a wrapper for the `SimilarProductsRecoSlider` component.
 * It encapsulates the data from the product query needed for the `SimilarProductsRecoSlider` component and passes correct props.
 */
export const SimilarProducts = ({ data }: SimilarProductsProps) => {
  const { hasSeries, orderNumber, promotion } = getFragmentData(
    SimilarRecoFragmentFragmentDoc,
    data,
  );
  const { formatMessage } = useIntl();

  // can be removed after abc test
  const { setOutcome, setRelevantProduct } = useAbTesting();

  return (
    <SimilarProductsRecoSlider
      productId={`${orderNumber}${promotion}`}
      elementIndex={hasSeries ? 3 : 2}
      fetchOnThreshold
      pageTemplate="detailview"
      title={formatMessage(similarProductsFallbackHeadline)}
      key={`${orderNumber}${3}`}
      // can be removed after abc test
      onSeen={() => setOutcome(testId, { SEEN: 1 })}
      onProductClick={(_, sku) => {
        setOutcome(testId, { COF_AA: 1 });
        setRelevantProduct(testId, sku, 'AA');
      }}
    />
  );
};
